import { isPlatformBrowser } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { environment } from '../../../../enviroment/enviroment';
import { LinkService } from '../../../services/link.service';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-contact-us',
  imports: [SharedModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  titleService = inject(Title);
  metaService = inject(Meta);
  router = inject(Router);
  linkService = inject(LinkService);

  supportEmail = environment.ANGULAR_SUPPORT_EMAIL;
  supportPhone = environment.ANGULAR_PHONE_SHOW;
  platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    this.titleService.setTitle('Contact Us | Qautos');
    this.metaService.updateTag({
      name: 'description',
      content: 'The premier ride experience',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Contact Us | Qautos',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: 'Reach our support team for inquiries and bookings.',
    });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    if (isPlatformBrowser(this.platformId)) {
      this.linkService.setCanonicalUrl('/contact-us');
    }
  }
}
